<span class="sr-only" aria-live="assertive" aria-atomic="true">{{ activeOptionText }}</span>
<mat-form-field
  appearance="outline"
  class="full-width user-input-form"
  style="margin-bottom: 20px; margin-top: 4px;"
>
  <input
    type="text"
    matInput
    [placeholder]="'employee_search_placeholder' | translate"
    [(ngModel)]="searchText"
    [matAutocomplete]="auto"
    (focus)="filterEmployees()"
    (input)="filterEmployees()"
    class="user-input-form-text-field"
    [attr.aria-label]="'employee_search_aria' | translate"
    required
  />
  <mat-autocomplete
    (optionActivated)="onOptionActivated($event)"
    (optionSelected)="onEmployeeChange($event)"
    #auto="matAutocomplete"
    [displayWith]="displayEmployeeName"
    [autoActiveFirstOption]="true"
  >
    <mat-option
      [attr.aria-label]="employee.employee_name"
      *ngFor="let employee of filteredEmployees"
      [value]="employee"
    >
      {{ employee.employee_name }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
